<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Follow Conversation</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            v-if="following_info != null"
            style="margin-top: 15px;"
        >

            <h2>{{following_info.label}}</h2>

            <div
                style="margin-top: 15px; margin-left: 15px;"
            >
                {{following_status_pretty_print}}
            </div>

            <div
                style="text-align: right; margin-top: 15px;"
            >

                <v-btn
                    v-on:click="onClickViewAllFollowing"
                >
                    All conversations you are following...
                </v-btn>
                
                <v-btn
                    v-on:click="onClickStopFollowConversation"
                    style="margin-left: 15px;"
                    v-if="can_stop_following"
                >
                    Stop Following
                </v-btn>

                <v-btn
                    v-on:click="onClickStartFollowConversation"
                    style="margin-left: 15px;"
                    v-if="can_start_following"
                >
                    Start Following
                </v-btn>

                <v-btn
                    v-on:click="onClickDiscardChanges"
                    style="margin-left: 15px;"
                    color="primary"
                >
                    Ok
                </v-btn>
            
                

            </div>

            
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,

            following_info : null,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;

            this.$rc.showSpinner();
            
            this.$rc.getFollowConversationInformation(
                this.$route.params.conversation_id,
                this.$route.params.endpoint,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.following_info = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get following information');
                    this.closeDialog();
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save 
                this.save();
                this.dialog = false;
                next(false);
                return;
            }
        
            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickStartFollowConversation()
        {
            this.closeDialog();
                    
            let params = {
                'conversation_id' : this.$route.params.conversation_id,
                'action' : 'start-following'
            };

            this.$rc.showSpinner();
            
            this.$rc.followConversation(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar("You are following this conversation.");
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to follow conversation.');
                },
            );
        },

        onClickStopFollowConversation()
        {
            this.closeDialog();
                    
            let params = {
                'conversation_id' : this.$route.params.conversation_id,
                'action' : 'stop-following'
            };

            this.$rc.showSpinner();
            
            this.$rc.followConversation(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar("You have stopped following this conversation.");
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to stop following conversation.');
                },
            );
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            // TODO: add code to save changes here
        },

        onClickViewAllFollowing()
        {
            this.closeDialog();

             this.$router.push({
                'name': 'employee-following',
                'params' : {
                    'employee_id' : this.$rc.$state.employee_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

    },

    computed: {
        following_status_pretty_print()
        {
            let info = this.following_info;

            if ( info == null ) 
                return '';

            if ( info.following_endpoint )
            {
                return 'You are following every conversation on this phone number.  You will be notified of any new messages in this conversation.';
            }

            if ( info.following_conversation )
            {
                return 'You have chosen to follow this conversation.  You will be notified of any new messages in this conversation.';
            }

            return 'You are not following this conversation.  You will not be notified of any new messages in this conversation.';
        },

        can_stop_following()
        {
            let info = this.following_info;

            if ( info == null ) 
                return false;

            return !info.following_endpoint && info.following_conversation;
        },

        can_start_following()
        {
            let info = this.following_info;

            if ( info == null ) 
                return false;

            return !info.following_endpoint && !info.following_conversation;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>